import { ApolloClient, gql } from '@apollo/client';
import { FlightOptionsQuery, FlightOptionsQueryVariables } from '@gql/schema';

export const LOG_MUTATION = gql`
  mutation Log($data: String!) {
    storeContext(context: $data)
  }
`;

export const OFFERS_QUERY = gql`
  query Offers($saleId: String!, $affiliate: String, $territory: String) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      id
      offers {
        id
        title
        description
        rateCode
        cancellationInfo {
          isRefundable
          description
          descriptionWithFlights
          descriptionWarning
          descriptionWarningWithFlights
          numberOfDays
        }
        details {
          longDescription
        }
        room {
          info {
            childPolicy
            singlePolicy
          }
          limit {
            maxAdults
            maxInfants
            maxChildren
            maxDependants
            maxChildAge
            minChildAge
            maxInfantAge
            minInfantAge
          }
          roomDescription
          roomType
          roomTypePlural
          photos {
            url
            urlWithSize
            caption
            maxHeight
            maxWidth
          }
        }
        prices {
          discount
          discountTooltip
          leadRate {
            unit
            forDisplay
          }
          leadRateLabel
          leadRateTooltip
          rackRate {
            forDisplay
          }
          maxAvailability
          pricingRules {
            showDiscount
            showRackRate
          }
        }
      }
    }
  }
`;

export const CALENDAR_QUERY = gql`
  query Calendar(
    $saleId: String!
    $affiliate: String
    $territory: String
    $packageGroups: [String!]!
    $rooms: Int
    $people: [PersonInput!]
    $groups: [GroupsInput!]
    $nights: [Int!]!
    $departureAirports: [String!]!
  ) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      calendar(
        packageGroups: $packageGroups
        rooms: $rooms
        people: $people
        groups: $groups
        nights: $nights
        departureAirports: $departureAirports
      ) {
        packagePriceBasis {
          adults
          children
          infants
          isPerNight
          mode
        }
        firstAvailableCheckInDate
        lastAvailableCheckInDate
        lastAvailableCheckOutDate
        checkInDates {
          date
          amount
          amountForDisplay
          isRefundable
          checkOutDates {
            date
            nights
            amount
            amountForDisplay
          }
        }
      }
    }
  }
`;

export const RECEIPTS_QUERY = gql`
  query Receipts(
    $saleId: String!
    $tracyOfferId: String!
    $territory: String
    $date: String!
    $nights: Int!
    $rooms: Int
    $people: [PersonInput!]
    $groups: [GroupsInput!]
    $departureAirports: [String!]!
  ) {
    sale(saleId: $saleId, territory: $territory) {
      id
      offers {
        id
        receipt(
          tracyOfferId: $tracyOfferId
          date: $date
          nights: $nights
          rooms: $rooms
          people: $people
          groups: $groups
          departureAirports: $departureAirports
        ) {
          amount
          amountForDisplay
          nights
          isRefundable
          maxAvailability
        }
      }
    }
  }
`;

export const FLIGHT_OPTIONS_QUERY = gql`
  query flightOptions(
    $saleId: String!
    $affiliate: String
    $territory: String
    $flightsEnabled: Boolean!
    $offerId: String
    $departureAirportCode: String
    $duration: Int
  ) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      id
      flights(
        flightsEnabled: $flightsEnabled
        offerId: $offerId
        departureAirportCode: $departureAirportCode
        duration: $duration
      ) {
        offers {
          offerId
          price
          priceForDisplay
          externalReference
        }
        airports {
          departureAirportCode
          departureAirportName
          price
          priceForDisplay
        }
        durations {
          duration
          price
          priceForDisplay
        }
      }
    }
  }
`;

export const fetchFlightOptions = (
  client: ApolloClient<object>,
  variables: FlightOptionsQueryVariables
) => {
  return client.query<FlightOptionsQuery, FlightOptionsQueryVariables>({
    query: FLIGHT_OPTIONS_QUERY,
    variables,
  });
};
